import GiftWrapRepository from './GiftWrapRepository';

export default GiftWrapRepository;